// src/features/customer-space/preview/LoyaltyPreviewContext.tsx
import React, {createContext, useContext} from "react";
import type { FacilityLoyaltyInfos } from "../../loyalty/api/useLoyaltyProgram";
import type { LoyaltyLevelPublic } from "../../loyalty/api/useLoyaltyLevel";

type LoyaltyPreviewValue = {
    info?: Partial<FacilityLoyaltyInfos> | null;
    levels?: LoyaltyLevelPublic[] | null;
};

const Ctx = createContext<LoyaltyPreviewValue>({ info: null, levels: null });

export function LoyaltyPreviewProvider({ value, children }: { value: LoyaltyPreviewValue; children: React.ReactNode }) {
    return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useLoyaltyPreview() {
    return useContext(Ctx);
}
